const state = {
  sound: '',
  soundNext: '',
  soundIsVoice: false,
  soundShouldQueue: false,
  soundFromTooltip: false,
  soundRequestClearAll: false,
  soundRequestClearLastTooltipVoice: false,
  soundSubmitter: 0, // exists only to be watched by SoundManager
};

const mutations = {
  setSound(state, {
    sound,
    soundNext = '',
    soundRequestClearAll = false,
    soundIsVoice = false,
    soundShouldQueue = false,
    soundFromTooltip = false,
    soundRequestClearLastTooltipVoice = false,
  }) {
    state.sound = sound || '';
    state.soundNext = soundNext || '';
    state.soundRequestClearAll = soundRequestClearAll;
    state.soundIsVoice = soundIsVoice;
    state.soundShouldQueue = soundShouldQueue;
    state.soundFromTooltip = soundFromTooltip;
    state.soundRequestClearLastTooltipVoice = soundRequestClearLastTooltipVoice;
  },
  submitSound(state) {
    state.soundSubmitter += 1;
    if (state.soundSubmitter > 100) state.soundSubmitter = 0;
  },
};

const actions = {
  playSound({ commit }, { sound, soundNext = '', soundRequestClearAll = false, }) {
    commit('setSound', { sound, soundNext, soundRequestClearAll });
    commit('submitSound');
  },
  playVoice({ commit }, { line, next = '', tooltip = false, queue = false, }) {
    let sound = line;
    if (line && line.audioUrl && typeof line.audioUrl === 'string') {
      sound = line.audioUrl;
    } else {
      console.warn('Failed to play voice line because it has no audioUrl', line);
      sound = '';
    }
    let soundNext = next;
    if (next && next.audioUrl && typeof next.audioUrl === 'string') {
      soundNext = next.audioUrl;
    } else {
      console.warn('Failed to play voice line because it has no audioUrl', next);
      soundNext = '';
    }
    commit('setSound', { sound, soundNext, soundIsVoice: true, soundShouldQueue: queue, soundFromTooltip: tooltip, });
    commit('submitSound');
  },
  stopSounds({ commit }) {
    commit('setSound', { sound: '', soundNext: '', soundRequestClearAll: true });
    commit('submitSound');
  },
  stopLastTooltipVoiceIfPlaying({ commit }) {
    commit('setSound', { sound: '', soundRequestClearLastTooltipVoice: true, });
    commit('submitSound');
  },
};

const getters = {
  sound({ sound }) { return sound; },
  soundNext({ soundNext }) { return soundNext; },
  soundRequestClearAll({ soundRequestClearAll }) { return soundRequestClearAll; },
  soundRequestClearLastTooltipVoice({ soundRequestClearLastTooltipVoice }) { return soundRequestClearLastTooltipVoice; },
  soundSubmitter({ soundSubmitter }) { return soundSubmitter; },
  soundIsVoice({ soundIsVoice }) { return soundIsVoice; },
  soundShouldQueue({ soundShouldQueue }) { return soundShouldQueue; },
  soundFromTooltip({ soundFromTooltip }) { return soundFromTooltip; },
};

export default {
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/audio/sound.js